<h1 mat-dialog-title>Es ist ein Fehler aufgetreten - {{data.StatusCode}}</h1>
<mat-dialog-content>
    {{data.Message}}
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-button
            color="primary"
            mat-dialog-close>ok</button>
</mat-dialog-actions>